import { $Color } from '@suntex.core/types';
import { GAME_COLLECTION_TAG_PATHS } from '@suntex.fim/framework';

import { NodeModel } from '../../../types';

import { modulesNode } from './modules';

export const algebraGoalsNode: NodeModel = {
  tag: GAME_COLLECTION_TAG_PATHS.algebraReadiness,
  info: {
    title: 'Algebra Readiness',
    summary: 'Improve your Algebra Goals Metric!',
  },
  label: 'Algebra Readiness',
  color: $Color.from('#ff6600'),
  filterTagPath: GAME_COLLECTION_TAG_PATHS.algebraReadiness,
  filterRoot: modulesNode,
};
